module.exports = __webpack_public_path__ + "static/media/fo.bbf423af.svg";